import Modules from 'root/apps/shared_modules/Modules';

import { BackbookBanner } from '../BackbookBanner/BackbookBanner';
import { CapitalHeroBanner } from '../versions';
import { UseOfferData } from './useOfferData';

export const useCapitalBannerComponent = (offerData: UseOfferData) => {
  if (
    !offerData.isLoading &&
    Modules.hasModule('reports.capital.backbook') &&
    offerData.isBackbookOffer
  ) {
    return BackbookBanner;
  }

  return CapitalHeroBanner;
};
